import React from 'react';
import AutosizeInput from 'react-input-autosize';
import { styled } from 'styled-components';

import type { FieldRenderProps } from '@/js/libs/final-form/index.ts';

import Icons from '../../Elements/Icons/index.tsx';

const IconsEdit = styled(Icons.Edit)`
  cursor: pointer;
`;

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  position: relative;
  padding-right: 26px;
  align-self: flex-start;
  input {
    font-size: 22px;
    line-height: 26px;
    border-width: 0 0 1px 0;
    border-style: solid;
    background: none;
    color: ${({ theme }) => theme.colors.black_1};
    padding: 0 0 1px 0;
    outline: none;
    &[readonly] {
      border-color: transparent;
    }
  }
`;

export interface IEditableTitle extends FieldRenderProps<string, HTMLInputElement>, Omit<React.HTMLProps<HTMLInputElement>, 'css'> {
  className?: string;
}

const EditableTitle: React.FC<IEditableTitle> = (props) => {
  const { className = '', input, meta: _meta, ...other } = props;

  const inputField = React.useRef<HTMLInputElement>(null);
  const [readonly, setReadonly] = React.useState<boolean>(true);

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-restricted-syntax
  const focusInputField = React.useCallback(() => {
    setReadonly(false);
    inputField.current?.focus();
  }, [inputField, setReadonly]);

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-restricted-syntax
  const onBlur = React.useCallback(() => {
    setReadonly(true);
  }, [setReadonly]);

  return (
    <Wrapper data-testid='placement-name-field'>
      <AutosizeInput
        className={className}
        // @ts-expect-error issue with AutosizeInput types - expected ref like string
        ref={inputField}
        {...input}
        onBlur={onBlur}
        readOnly={readonly}
        {...other}
      />
      {readonly && <IconsEdit size={26} onClick={focusInputField} />}
    </Wrapper>
  );
};

export default EditableTitle;
